import { jfetch, snakeCaseKeys } from "../utils";

export function findCompany(query: string) {
  return jfetch.get<{ companies: ICtCompanySearchResult[] }>(
    "/api/ct_cw/find_company",
    { query }
  );
}

export function getContacts(
  companyRecId: string,
  options?: { firstName: string; lastName: string }
) {
  const params = { company_recid: companyRecId };

  if (options) {
    Object.assign(params, snakeCaseKeys(options));
  }

  return jfetch.get<{ contacts: ICtGetContactsResult[] }>(
    "/api/ct_cw/get_contacts",
    params
  );
}

export function getPrimaryContact(companyRecId: string) {
  const params = { company_recid: companyRecId };
  return jfetch.get(
    "/api/ct_cw/get_primary_contact",
    params
  );
}

export function getCompanyCwUrl(companyRecId: string) {
  return `https://cw.chartec.net/v4_6_release/services/system_io/router/openrecord.rails?locale=en_US&recordType=CompanyFV&recid=${companyRecId}&companyName=CharTec`;
}

export function getEmailFromContact(contact: ICtGetContactsResult) {
  if (!contact.communicationItems) {
    return null;
  }
  const item = contact.communicationItems.find(
    i => i.defaultFlag && i.communicationType === "Email"
  );
  return item ? item.value : null;
}

export function getFullNameFromContact(contact: ICtGetContactsResult) {
  return `${contact.firstName} ${contact.lastName}`;
}

export function createTicket(ticketParams: ICtCreateTicketParams) {
  return jfetch.post('/api/ct_cw/create_ticket', ticketParams);

}


// WEBPACK FOOTER //
// ./app/javascript/libs/chartec_cw.ts